/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createTypesMap } from './types';

export const types = createTypesMap('mark', [
  'handleMark',
]);

const handleMark = createAction(types.handleMark, mark => mark);

export default {
  handleMark,
};




// WEBPACK FOOTER //
// ./src/redux/actions/mark.js